/**
 * Callback Page
 *
 * Handles Auth0 redirect after successful login
 * Shows loading state while processing authentication
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export function CallbackPage() {
  const navigate = useNavigate();
  const { isLoading, error } = useAuth0();

  useEffect(() => {
    if (isLoading) return;

    if (error) {
      console.error('Authentication error:', error);
      navigate('/');
      return;
    }

    // Authentication successful, redirect to home
    navigate('/');
  }, [isLoading, error, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mb-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Processing Login...</h1>
        <p className="text-gray-600">Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
}
